import axios from "axios";

class ReligionApi {
    constructor() {
        // Load from local public folder
        this.baseURL = '/master-data';
    }
    
    async listReligionWithCaste() {
        const response = await axios.get(`${this.baseURL}/religions.json`);
        return { data: response.data };
    }
    
    async listGothras(religionId = null) {
        const response = await axios.get(`${this.baseURL}/castes.json`);
        let castes = response.data;
        if (religionId) {
            castes = castes.filter(c => c.religionId === religionId);
        }
        return { data: castes };
    }
    
    async listMotherTongues() {
        const response = await axios.get(`${this.baseURL}/languages.json`);
        return { data: response.data };
    }
    
    async listCountries() {
        const response = await axios.get(`${this.baseURL}/countries.json`);
        return { data: response.data };
    }
    
    async listStates(countryId = null) {
        const response = await axios.get(`${this.baseURL}/states.json`);
        let states = response.data;
        if (countryId) {
            states = states.filter(s => s.countryId === countryId);
        }
        return { data: states };
    }
    
    async listCities(stateId = null, countryId = null) {
        const response = await axios.get(`${this.baseURL}/cities.json`);
        let cities = response.data;
        if (stateId) {
            cities = cities.filter(c => c.stateId === stateId);
        } else if (countryId) {
            cities = cities.filter(c => c.countryId === countryId);
        }
        // Sort: popular cities first
        cities.sort((a, b) => {
            if (a.isPopular && !b.isPopular) return -1;
            if (!a.isPopular && b.isPopular) return 1;
            return a.label.localeCompare(b.label);
        });
        return { data: cities };
    }
}

export default ReligionApi = new ReligionApi();